<script>
  /**
   * @type {string}
   */
  export let label

  export let checked = false

  export let disabled = false

  /**
   * @type {string}
   */
  export let name = ""

  export let onClick = () => {}
</script>

<label class="checkbox-root" class:checked={checked} class:disabled={disabled}>
  <input
    name={name}
    type="checkbox"
    bind:checked={checked}
    disabled={disabled}
    on:click={onClick}
  />
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill={checked ? "#00468F" : "white"} stroke="#CCCCCC"/>
    {#if checked}
      <path d="M5 11L10 16L19 7" stroke="white" stroke-width="3"/>
    {/if}
  </svg>
  <span style="margin-left: 8px">
    {#if label}
      {label}
    {:else}
      <slot/>
    {/if}
  </span>
</label>

<style>
  input {
    display: none;
    cursor: pointer;
  }

  .checkbox-root {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  .checkbox-root.disabled {
    cursor: default;
  }

  .disabled svg {
    filter: opacity(0.5);
  }
</style>
